// frontend/src/components/book/atelier/store/uiReducer.js
//
// ETAT D'INTERFACE de l'atelier : ce qu'on regarde et ce qui est ouvert.
// Volontairement SEPARE de l'etat du livre (bookReducer.js) : rien de ce qui
// est ici n'est enregistre, rien n'entre dans l'historique annuler/retablir.
// Choisir une photo dans la bibliotheque, ouvrir un panneau ou feuilleter ne
// doit ni declencher une sauvegarde ni etre "annule" par Ctrl+Z.

export const UI_ACTIONS = {
  SET: 'ui/set',
  SET_MANY: 'ui/setMany',
  TOAST_PUSH: 'ui/toastPush',
  TOAST_DISMISS: 'ui/toastDismiss'
};

export const createInitialUiState = () => ({
  // 0 = couverture, dernier = 4e, sinon double page.
  viewIndex: 0,
  selectedSide: 'left',
  // Photo/souvenir "pris en main" dans la bibliotheque, pret a etre depose.
  selectedSidebarItem: null,
  // Onglet du panneau fixe de gauche : 'photos' | 'layout'.
  activeDrawer: 'photos',
  // Fenetres/selecteurs ouverts sur UN emplacement (index) ou UNE face.
  pendingAdjustItemId: null,
  pickerTargetSlotIndex: null,
  pickerTargetCoverFace: null,
  // Photo SELECTIONNEE pour le cadrage (barre flottante) : { type: 'slot',
  // pageIndex, slotIndex } | { type: 'cover', face } | null.
  selectedFraming: null,
  // Emplacement de texte en cours d'edition sur la page (index) ou null.
  editingTextSlot: null,
  // Messages flottants (bas de l'ecran) : { id, message, actionLabel, persistent }.
  toasts: []
});

export const MAX_TOASTS = 3;

export function uiReducer(state, action) {
  switch (action.type) {
    case UI_ACTIONS.SET: {
      const value = typeof action.value === 'function' ? action.value(state[action.key]) : action.value;
      return Object.is(state[action.key], value) ? state : { ...state, [action.key]: value };
    }
    case UI_ACTIONS.SET_MANY:
      return { ...state, ...action.patch };
    case UI_ACTIONS.TOAST_PUSH: {
      // Un message de meme identifiant REMPLACE l'ancien (le dernier "Annuler"
      // vaut mieux que trois empiles) ; au plus MAX_TOASTS visibles.
      const rest = state.toasts.filter((toast) => toast.id !== action.toast.id);
      return { ...state, toasts: [...rest, action.toast].slice(-MAX_TOASTS) };
    }
    case UI_ACTIONS.TOAST_DISMISS:
      return { ...state, toasts: state.toasts.filter((toast) => toast.id !== action.id) };
    default:
      return state;
  }
}
